import { MapMarker, PinVariant } from '../../../components/Map/Map.interface';
import { ProductStoreInterface } from '../../../services/product.services';

const hasCoordinates = (store: ProductStoreInterface) => {
	const coordinates = store?.location?.coordinates;
	return (
		Array.isArray(coordinates) &&
		coordinates.length >= 2 &&
		Number.isFinite(Number(coordinates[0])) &&
		Number.isFinite(Number(coordinates[1]))
	);
};

/**
 * A store saved without a location (or a half-created one) used to throw on
 * `location.coordinates` and blank the whole "My stores" page — the first
 * screen a new seller lands on. Such stores simply get no pin.
 */
export const storeToMarker = (
	store: ProductStoreInterface,
): MapMarker | undefined =>
	hasCoordinates(store)
		? {
				latitude: Number(store.location.coordinates[1]),
				longitude: Number(store.location.coordinates[0]),
				variant: PinVariant.product_store,
				store: {
					name: store.name,
					countryCode: store.countryCode,
					productCount: store.productCount?.toString(),
				},
		  }
		: undefined;

export const storesToMarkers = (
	stores: ProductStoreInterface[] | undefined,
): MapMarker[] =>
	(stores ?? [])
		.map(storeToMarker)
		.filter((marker): marker is MapMarker => !!marker);
